import React from 'react';
import { jwtDecode } from "jwt-decode";
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element, allowedRoles }) => {
    const token = localStorage.getItem('token');
    if (!token || typeof token !== 'string') {
        return <Navigate to="/login" />;
    }

    try {
        const decodedToken = jwtDecode(token);
        const id_tipo_usuario = decodedToken.id_tipo_usuario;
  
        if (allowedRoles.includes(id_tipo_usuario)) {
            return element;
        } else {
            return <Navigate to="/login" />;
        }
    } catch (error) {
        console.error('Error decodificando el token', error);
        return <Navigate to="/login" />;
    }
};

export default ProtectedRoute;
